
export const adTypes = [
    { id: 'banner', name: 'Banner' },
    { id: 'video', name: 'Video' },
    { id: 'popup', name: 'Popup' }
];


export const userSegments = [
    { id: 'all', name: 'All Users' },
    { id: 'premium', name: 'Premium Users' },
    { id: 'free', name: 'Free Users' },
    { id: 'new', name: 'New Users' },
    { id: 'returning', name: 'Returning Users' }
];

export const countries = [
    { id: 'af', name: 'Afghanistan' },
    { id: 'al', name: 'Albania' },
    { id: 'dz', name: 'Algeria' },
    { id: 'ad', name: 'Andorra' },
    { id: 'ao', name: 'Angola' },
    { id: 'ag', name: 'Antigua and Barbuda' },
    { id: 'ar', name: 'Argentina' },
    { id: 'am', name: 'Armenia' },
    { id: 'au', name: 'Australia' },
    { id: 'at', name: 'Austria' },
    { id: 'az', name: 'Azerbaijan' },
    { id: 'bs', name: 'Bahamas' },
    { id: 'bh', name: 'Bahrain' },
    { id: 'bd', name: 'Bangladesh' },
    { id: 'bb', name: 'Barbados' },
    { id: 'by', name: 'Belarus' },
    { id: 'be', name: 'Belgium' },
    { id: 'bz', name: 'Belize' },
    { id: 'bj', name: 'Benin' },
    { id: 'bt', name: 'Bhutan' },
    { id: 'bo', name: 'Bolivia' },
    { id: 'ba', name: 'Bosnia and Herzegovina' },
    { id: 'bw', name: 'Botswana' },
    { id: 'br', name: 'Brazil' },
    { id: 'bn', name: 'Brunei' },
    { id: 'bg', name: 'Bulgaria' },
    { id: 'bf', name: 'Burkina Faso' },
    { id: 'bi', name: 'Burundi' },
    { id: 'cv', name: 'Cabo Verde' },
    { id: 'kh', name: 'Cambodia' },
    { id: 'cm', name: 'Cameroon' },
    { id: 'ca', name: 'Canada' },
    { id: 'cf', name: 'Central African Republic' },
    { id: 'td', name: 'Chad' },
    { id: 'cl', name: 'Chile' },
    { id: 'cn', name: 'China' },
    { id: 'co', name: 'Colombia' },
    { id: 'km', name: 'Comoros' },
    { id: 'cg', name: 'Congo' },
    { id: 'cr', name: 'Costa Rica' },
    { id: 'ci', name: "Côte d'Ivoire" },
    { id: 'hr', name: 'Croatia' },
    { id: 'cu', name: 'Cuba' },
    { id: 'cy', name: 'Cyprus' },
    { id: 'cz', name: 'Czech Republic' },
    { id: 'dk', name: 'Denmark' },
    { id: 'dj', name: 'Djibouti' },
    { id: 'dm', name: 'Dominica' },
    { id: 'do', name: 'Dominican Republic' },
    { id: 'ec', name: 'Ecuador' },
    { id: 'eg', name: 'Egypt' },
    { id: 'sv', name: 'El Salvador' },
    { id: 'gq', name: 'Equatorial Guinea' },
    { id: 'er', name: 'Eritrea' },
    { id: 'ee', name: 'Estonia' },
    { id: 'sz', name: 'Eswatini' },
    { id: 'et', name: 'Ethiopia' },
    { id: 'fj', name: 'Fiji' },
    { id: 'fi', name: 'Finland' },
    { id: 'fr', name: 'France' },
    { id: 'ga', name: 'Gabon' },
    { id: 'gm', name: 'Gambia' },
    { id: 'ge', name: 'Georgia' },
    { id: 'de', name: 'Germany' },
    { id: 'gh', name: 'Ghana' },
    { id: 'gr', name: 'Greece' },
    { id: 'gd', name: 'Grenada' },
    { id: 'gt', name: 'Guatemala' },
    { id: 'gn', name: 'Guinea' },
    { id: 'gw', name: 'Guinea-Bissau' },
    { id: 'gy', name: 'Guyana' },
    { id: 'ht', name: 'Haiti' },
    { id: 'hn', name: 'Honduras' },
    { id: 'hu', name: 'Hungary' },
    { id: 'is', name: 'Iceland' },
    { id: 'in', name: 'India' },
    { id: 'id', name: 'Indonesia' },
    { id: 'ir', name: 'Iran' },
    { id: 'iq', name: 'Iraq' },
    { id: 'ie', name: 'Ireland' },
    { id: 'il', name: 'Israel' },
    { id: 'it', name: 'Italy' },
    { id: 'jm', name: 'Jamaica' },
    { id: 'jp', name: 'Japan' },
    { id: 'jo', name: 'Jordan' },
    { id: 'kz', name: 'Kazakhstan' },
    { id: 'ke', name: 'Kenya' },
    { id: 'kw', name: 'Kuwait' },
    { id: 'la', name: 'Laos' },
    { id: 'lv', name: 'Latvia' },
    { id: 'lb', name: 'Lebanon' },
    { id: 'ly', name: 'Libya' },
    { id: 'lt', name: 'Lithuania' },
    { id: 'lu', name: 'Luxembourg' },
    { id: 'mg', name: 'Madagascar' },
    { id: 'my', name: 'Malaysia' },
    { id: 'mx', name: 'Mexico' },
    { id: 'ma', name: 'Morocco' },
    { id: 'na', name: 'Namibia' },
    { id: 'np', name: 'Nepal' },
    { id: 'nl', name: 'Netherlands' },
    { id: 'nz', name: 'New Zealand' },
    { id: 'ni', name: 'Nicaragua' },
    { id: 'ng', name: 'Nigeria' },
    { id: 'no', name: 'Norway' },
    { id: 'pk', name: 'Pakistan' },
    { id: 'pa', name: 'Panama' },
    { id: 'py', name: 'Paraguay' },
    { id: 'pe', name: 'Peru' },
    { id: 'ph', name: 'Philippines' },
    { id: 'pl', name: 'Poland' },
    { id: 'pt', name: 'Portugal' },
    { id: 'qa', name: 'Qatar' },
    { id: 'ro', name: 'Romania' },
    { id: 'ru', name: 'Russia' },
    { id: 'sa', name: 'Saudi Arabia' },
    { id: 'rs', name: 'Serbia' },
    { id: 'sg', name: 'Singapore' },
    { id: 'za', name: 'South Africa' },
    { id: 'es', name: 'Spain' },
    { id: 'se', name: 'Sweden' },
    { id: 'ch', name: 'Switzerland' },
    { id: 'th', name: 'Thailand' },
    { id: 'tr', name: 'Turkey' },
    { id: 'ua', name: 'Ukraine' },
    { id: 'ae', name: 'United Arab Emirates' },
    { id: 'gb', name: 'United Kingdom' },
    { id: 'us', name: 'United States' },
    { id: 'uy', name: 'Uruguay' },
    { id: 've', name: 'Venezuela' },
    { id: 'vn', name: 'Vietnam' },
    { id: 'zw', name: 'Zimbabwe' }
];
